var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSaving(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 66,
    viewBox: "0 0 65 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32.7342,
    r: 32.5,
    fill: "#0156FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1264_7796)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.2045 21.2289C45.129 21.0411 44.9841 20.8896 44.7998 20.8059C44.6155 20.7222 44.406 20.7127 44.215 20.7796C44.0239 20.8464 43.866 20.9843 43.774 21.1646C43.682 21.3449 43.6631 21.5537 43.7212 21.7476C44.9289 25.2186 42.5317 27.8108 40.7039 29.1992L39.9655 28.141C39.7172 27.7861 39.1621 27.491 38.7305 27.4858L34.5861 27.504C34.0798 27.5193 33.5871 27.6711 33.16 27.9434L20.9478 36.5065C20.6637 36.7064 20.4704 37.0107 20.4102 37.3528C20.3501 37.6949 20.4279 38.0469 20.6267 38.3317L26.1764 46.2721C26.5924 46.8636 27.2567 46.7921 27.8495 46.3787L40.0617 37.8143C40.4127 37.566 40.8183 37.0304 40.9613 36.6209L42.2587 32.5324C42.4017 32.1242 42.3146 31.5015 42.0663 31.1466L41.6165 30.5018C44.0709 28.6207 46.6189 25.2966 45.2045 21.2289ZM39.5222 33.3943C39.2972 33.5518 39.0434 33.6634 38.7753 33.7228C38.5071 33.7821 38.2299 33.7881 37.9595 33.7403C37.6891 33.6925 37.4307 33.5918 37.1992 33.4441C36.9677 33.2965 36.7675 33.1046 36.6102 32.8795C36.2916 32.4241 36.1667 31.8608 36.263 31.3134C36.3593 30.766 36.6688 30.2791 37.1237 29.9597C37.4803 29.7099 37.906 29.5777 38.3414 29.5817C38.7768 29.5856 39.2001 29.7255 39.5521 29.9818C39.1985 30.195 38.9554 30.3198 38.9099 30.3393C38.7487 30.4162 38.6184 30.5454 38.5404 30.706C38.4623 30.8666 38.4411 31.0489 38.4803 31.2231C38.5194 31.3973 38.6165 31.553 38.7558 31.6648C38.895 31.7765 39.068 31.8377 39.2466 31.8382C39.3584 31.8382 39.4728 31.8122 39.5807 31.7615C39.8329 31.6419 40.1033 31.5002 40.3854 31.3325C40.4503 31.7226 40.4037 32.1231 40.2509 32.4878C40.0982 32.8526 39.8456 33.1668 39.5222 33.3943Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1264_7796"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(20 20.7024)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaving);
export default __webpack_public_path__ + "static/media/saving.9feab4244bfda09db6608dd597eed527.svg";
export { ForwardRef as ReactComponent };